import { app } from '../../../../app';

app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('public.email-verification', {
        url: '/verification?vkey',
        component: 'emailVerification',
    });
}



// WEBPACK FOOTER //
// ./src/portal/states/public/verification/email/email-verification.state.js